<div *ngIf="visible">
    <div class="dialog-background"></div>
    <div class="dialog-container">
        <div class="dialog-box">
            <div class="{{size}}" [ngClass]="{'center-text': centerContent}">
                <div class="close-dialog-box" *ngIf="!withoutCloseIcon" (click)="cancel()"
                    data-test="yes-no-dialog-close"></div>

                <ng-container *ngIf="customHeader; else standardHeader">
                    <div class="header" data-test="yes-no-dialog-header">
                        <ng-content select="[header]"></ng-content>
                    </div>
                </ng-container>

                <ng-template #standardHeader>
                    <div *ngIf="header" class="header" data-test="yes-no-dialog-header">
                        {{header}}
                    </div>
                </ng-template>

                <ng-container *ngIf="customContent; else standardDialogBox">
                    <div class="content">
                        <ng-content select="[content]"></ng-content>
                    </div>
                </ng-container>

                <ng-template #standardDialogBox>
                    <div class="content">
                        <p data-test="yes-no-dialog-text-content" [class.wrapped]="wrapped"> {{content}}</p>
                    </div>
                    <!-- <div class="button-row left-aligned-button-row" [ngClass]="{'center-aligned-items': centerContent}">
                         -->
                    <!--  <div class="buttons">
                        <div class="left">
                        </div>
                        <div class="right">
                            <button class="btn btn-primary" style="margin-right: 16px;"
                                (click)="confirm()">{{confirmText}}</button>
                            <button class="btn btn-primary cancel" (click)="cancel()"></button>
                        </div>
                    </div> -->
                </ng-template>
                <div *ngIf="confirmText||cancelText" class="dialog-box__button-wrapper">
                    <button *ngIf="cancelText" class="btn btn-primary dialog-box__button dialog-box__button-cancel" type="button"
                        (click)="cancel()" [ngClass]="{'dialog-box__button--w50': singleBtn}" data-test="yes-no-dialog-action-cancel">{{cancelText}}</button>
                    <button *ngIf="confirmText" class="btn btn-primary dialog-box__button dialog-box__button-save"
                            [ngClass]="{'dialog-box__button--w50': singleBtn, 'dialog-box__button--danger': redConfirmButton}"
                            type="button" (click)="confirm()"
                        data-test="yes-no-dialog-action-confirm">{{confirmText}}</button>
                </div>

            </div>
        </div>
    </div>
</div>
